module.exports = function() {
    if (document.getElementsByClassName('load-more-content')[0]) {
        var $loadMoreButton = $('.load-more-content .load-more-text');
        $ul = $(".featured-grid-list");
        maxItems = $ul.attr("data-items");

        if ($ul.find("li").length > maxItems) {
            $(".load-more-content").show();
        }
        $loadMoreButton.click(function() {
            var idx = $ul.find("li.hidden").index();
            for (var i = 0; i < maxItems; i++) {
                if ($ul.find("li").eq(idx + i).length) {
                    $ul.find("li").eq(idx + i).removeClass("hidden");
                }
            }
            if ($ul.find("li.hidden").length <= 0) {
                $loadMoreButton.parent().hide();
            }
        });
    }
};